import React, { Component } from 'react';
import PropTypes from 'prop-types';
import plusIconPng from '../../../../images/plus-icon.png';
import './SubContractorsList.css';
import Dropdown from '../../../shared/dropdown/Dropdown';
import SimpleButton from '../../../shared/button/SimpleButton';
import removeIconPng from '../../../../images/remove.png';
import RadioButton from '../../../shared/radio-button/RadioButton';
import { Col, Clearfix } from 'react-bootstrap';

class SubContractorsList extends Component {
  static propTypes = {
    subContractorAnswer: PropTypes.string,
    subContractors: PropTypes.array.isRequired,
    selectedSubContractorsId: PropTypes.arrayOf(PropTypes.number).isRequired,
    validationError: PropTypes.string,
    onAddSubContractor: PropTypes.func,
    onQuestionResponse: PropTypes.func,
    onRemoveSubContractor: PropTypes.func,
    onSubContractorSelection: PropTypes.func,
  };

  handleSubContractorSelection = (newOption) => {
    this.props.onSubContractorSelection(newOption.value);
  };

  handleAddSubContractor = () => {
    this.props.onAddSubContractor();
  };

  handleRemove = (event, id) => {
    event.preventDefault();
    this.props.onRemoveSubContractor(id);
  };

  handleQuestion = (value) => {
    this.props.onQuestionResponse(value);
  };

  render() {
    return (
      <div className="sub-contractors-list">
        <div>Subcontractors</div>

        <div>
          Do you or your building require any proprietary subcontractors?
        </div>

        <Col sm={6}>
          <RadioButton
            options={[
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
              {
                value: 'dont-know',
                label: "I don't know",
              },
            ]}
            orientation="vertical"
            value={this.props.subContractorAnswer}
            onChange={this.handleQuestion}
          />
          {this.props.validationError !== '' && (
            <div className="invalid-message">{this.props.validationError}</div>
          )}
        </Col>

        <Col sm={6}>
          <div className="selection-container">
            {this.props.subContractorAnswer === 'yes' && this.getContent()}
          </div>
        </Col>

        <Clearfix />
      </div>
    );
  }

  getContent() {
    return (
      <React.Fragment>
        {this.props.selectedSubContractorsId.length > 0 ? (
          <ul>
            {this.props.subContractors
              .filter((element) => {
                // Return contractors selected
                const index = this.props.selectedSubContractorsId.find(
                  (selected) => selected === element.id
                );
                return index > -1;
              })
              .sort((a, b) => {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                return 0;
              })
              .map((element, index) => {
                return (
                  <li key={index}>
                    <span>{element.name}</span>
                    <img
                      src={removeIconPng}
                      alt="remove"
                      onClick={(event) => this.handleRemove(event, element.id)}
                    />
                  </li>
                );
              })}
          </ul>
        ) : null}

        <Dropdown
          className="sub-contractors-dropdown"
          options={this.props.subContractors
            .filter((element) => {
              // Show elements not selected
              const index = this.props.selectedSubContractorsId.findIndex(
                (selected) => selected === element.id
              );
              return index === -1;
            })
            .sort((a, b) => {
              if (a.name > b.name) {
                return 1;
              }
              if (a.name < b.name) {
                return -1;
              }
              return 0;
            })
            .map((element) => {
              return {
                value: element.id,
                label: element.name,
              };
            })}
          placeholder="Select from list"
          onChange={this.handleSubContractorSelection}
        />

        <p>OR</p>

        <SimpleButton
          className="sub-contractor-button"
          img={plusIconPng}
          label="Add Additional Subcontractor"
          onClick={this.handleAddSubContractor}
        />
      </React.Fragment>
    );
  }
}

export default SubContractorsList;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/SubContractorsList.js